import b1 from "./b1.png";
import b2 from "./b2.png";
import b3 from "./b3.png";
import b4 from "./b4.png";
import b5 from "./b5.png";
import b6 from "./b6.png";
import b7 from "./b7.png";
import b8 from "./b8.png";
import b9 from "./b9.png";
import b10 from "./b10.png";
import b11 from "./b11.png";
import b12 from "./b12.png";
import b13 from "./b13.png";
import b14 from "./b14.png";
import b15 from "./b15.png";
import b16 from "./b16.png";
import b17 from "./b17.png";
import b18 from "./b18.png";
import b19 from "./b19.png";
import b20 from "./b20.png";
import b21 from "./b21.png";
import b22 from "./b22.png";
import b23 from "./b23.png";
import b24 from "./b24.png";
import b25 from "./b25.png";
import b26 from "./b26.png";
import b27 from "./b27.png";
import b28 from "./b28.png";
import b29 from "./b29.png";
import b30 from "./b30.png";
import b31 from "./b31.png";
import b32 from "./b32.png";
import b33 from "./b33.png";
import b34 from "./b34.png";
import b35 from "./b35.png";
import b36 from "./b36.png";
import b37 from "./b37.png";
import b38 from "./b38.png";
import b39 from "./b39.png";
import b40 from "./b40.png";
import b41 from "./b41.png";
import b42 from "./b42.png";
import b43 from "./b43.png";
import b44 from "./b44.png";
import b45 from "./b45.png";
import b46 from "./b46.png";
import b47 from "./b47.png";
import b48 from "./b48.png";
import b49 from "./b49.png";
import b50 from "./b50.png";
import b51 from "./b51.png";
import b52 from "./b52.png";
import b53 from "./b53.png";
import b54 from "./b54.png";
import b55 from "./b55.png";
import b56 from "./b56.png";
import b57 from "./b57.png";
import b58 from "./b58.png";
import b59 from "./b59.png";
import b60 from "./b60.png";
import b61 from "./b61.png";
import b62 from "./b62.png";
import b63 from "./b63.png";
import b64 from "./b64.png";
import b65 from "./b65.png";
import b66 from "./b66.png";
import b67 from "./b67.png";
import b68 from "./b68.png";
import b69 from "./b69.png";
import b70 from "./b70.png";

const buildings: {[key: string]: any} = {
  b1,
  b2,
  b3,
  b4,
  b5,
  b6,
  b7,
  b8,
  b9,
  b10,
  b11,
  b12,
  b13,
  b14,
  b15,
  b16,
  b17,
  b18,
  b19,
  b20,
  b21,
  b22,
  b23,
  b24,
  b25,
  b26,
  b27,
  b28,
  b29,
  b30,
  b31,
  b32,
  b33,
  b34,
  b35,
  b36,
  b37,
  b38,
  b39,
  b40,
  b41,
  b42,
  b43,
  b44,
  b45,
  b46,
  b47,
  b48,
  b49,
  b50,
  b51,
  b52,
  b53,
  b54,
  b55,
  b56,
  b57,
  b58,
  b59,
  b60,
  b61,
  b62,
  b63,
  b64,
  b65,
  b66,
  b67,
  b68,
  b69,
  b70
}

export default buildings;
